import React from "react";

import { Container } from "./styled";

export const TextCell = ({ cell: { value } }) => {
    return <Container>{value}</Container>;
};
